import React, { useState, useEffect } from 'react';
import axios from '../api/axiosConfig';
import './Modal.css';

const EditModal = ({ isOpen, cupl, onClose, onSave, loading }) => {
  const [formData, setFormData] = useState({
    cupl_number: '',
    plate: '',
    owner_name: '',
    tramite_type_id: '',
    total_amount: '',
  });
  const [tramiteTypes, setTramiteTypes] = useState([]);
  const [error, setError] = useState('');
  const token = localStorage.getItem('token');

  // Cargar tipos de trámites
  useEffect(() => {
    const fetchTramiteTypes = async () => {
      try {
        const response = await axios.get('/api/tramite-types');
        setTramiteTypes(response.data);
      } catch (error) {
        console.error('Error al obtener tipos de trámites:', error);
      }
    };

    if (isOpen) {
      fetchTramiteTypes();
    }
  }, [isOpen, token]);

  useEffect(() => {
    if (cupl) {
      setFormData({
        cupl_number: cupl.cupl_number,
        plate: cupl.plate,
        owner_name: cupl.owner_name,
        tramite_type_id: cupl.tramite_type_id || '',
        total_amount: cupl.total_amount || '',
      });
      setError('');
    }
  }, [cupl, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.cupl_number || !formData.plate || !formData.owner_name) {
      setError('Todos los campos son requeridos');
      return;
    }

    onSave(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => !loading && onClose()}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>✏️ Editar CUPL</h2>
          <button 
            className="modal-close" 
            onClick={onClose}
            disabled={loading}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="cupl_number">Número CUPL:</label>
            <input
              type="text"
              id="cupl_number"
              name="cupl_number"
              value={formData.cupl_number}
              disabled
              className="disabled-input"
            />
            <small>No se puede cambiar el número CUPL</small>
          </div>

          <div className="form-group">
            <label htmlFor="plate">Placa:</label>
            <input
              type="text"
              id="plate"
              name="plate"
              value={formData.plate}
              onChange={handleChange}
              placeholder="Ej. ABC-123"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="owner_name">Propietario:</label>
            <input
              type="text"
              id="owner_name"
              name="owner_name"
              value={formData.owner_name}
              onChange={handleChange}
              placeholder="Nombre completo"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="total_amount">Valor a Pagar ($):</label>
            <input
              type="number"
              id="total_amount"
              name="total_amount"
              value={formData.total_amount}
              onChange={handleChange}
              placeholder="Ej. 90000"
              disabled={loading}
            />
            <small style={{ color: '#64748b', fontSize: '11px' }}>
              * Si se deja vacío, se usará el valor del Tipo de Trámite.
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="tramite_type_id">Tipo de Trámite:</label>
            <select
              id="tramite_type_id"
              name="tramite_type_id"
              value={formData.tramite_type_id}
              onChange={handleChange}
              disabled={loading}
            >
              <option value="">Seleccionar trámite...</option>
              {tramiteTypes.map(tramite => (
                <option key={tramite.id} value={tramite.id}>
                  {tramite.name} (${tramite.value.toLocaleString('es-CO')})
                </option>
              ))}
            </select>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="btn btn-cancel"
              onClick={onClose}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-save"
              disabled={loading}
            >
              {loading ? '⏳ Guardando...' : '✓ Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditModal;
